import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/** Password field with a show / hide eye. */
export const PasswordInput = ({ className = "", testId, ...props }) => {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <input {...props} data-testid={testId} type={shown ? "text" : "password"} className={`${className} pr-12`} />
      <button
        type="button"
        onClick={() => setShown((value) => !value)}
        aria-label={shown ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        aria-pressed={shown}
        className="absolute right-2 top-1/2 mt-1 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full text-[#829c8d] transition-colors hover:bg-[#F3FCF7] hover:text-[#189346]"
        data-testid={`${testId}-toggle`}
      >
        {shown ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};

export default PasswordInput;
